import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'containers/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import NewReport from 'containers/NewReport';
import NewIssue from 'containers/NewIssue';
import ExpiredPasswordModal from 'containers/ExpiredPasswordModal';
import { COLLAPSED_DRAWER, FIXED_DRAWER } from 'constants/ActionTypes';
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import InitialLoadingScreen from 'containers/InitialLoadingScreen';
import Tour from 'components/Tour/index';
import { resetIntroTour } from 'actions/Intro';

class App extends React.Component {
    render() {
        const { match, drawerType, navigationStyle } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER)
            ? 'fixed-drawer'
            : drawerType.includes(COLLAPSED_DRAWER)
            ? 'collapsible-drawer'
            : 'mini-drawer';
        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            document.body.classList.add('ios-mobile-view-height');
        } else if (document.body.classList.contains('ios-mobile-view-height')) {
            document.body.classList.remove('ios-mobile-view-height');
        }

        // Zeige Modal wenn das Passwort abgelaufen ist. Zwingt den User dazu ein neues Passwort zu setzen
        if (this.props.passwordExpired) return <ExpiredPasswordModal />;
        return (
            <div className={`app-container ${drawerStyle}`}>
                <InitialLoadingScreen />
                <Tour showTour={this.props.showTour} tourPage={this.props.tourPage} onReset={this.props.resetIntroTour} />
                {<Sidebar />}
                <NewIssue />
                <NewReport />
                <div className="app-main-container">
                    <div className="app-header">
                        <Header />
                    </div>
                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                            <Switch>
                                <Route
                                    path={`${match.url}/admin-dashboard`}
                                    component={asyncComponent(() => import('./routes/AdminDashboardPage'))}
                                />
                                <Route path={`${match.url}/admin-report`} component={asyncComponent(() => import('./routes/AdminReportPage'))} />
                                <Route
                                    path={`${match.url}/admin-organisations`}
                                    component={asyncComponent(() => import('./routes/AdminOrganisationPage'))}
                                />
                                <Route
                                    path={`${match.url}/admin-report-map`}
                                    component={asyncComponent(() => import('./routes/AdminReportMapPage'))}
                                />
                                <Route path={`${match.url}/admin-feedback`} component={asyncComponent(() => import('./routes/AdminFeedbackPage'))} />
                                <Route
                                    path={`${match.url}/admin-messaging`}
                                    component={asyncComponent(() => import('./routes/AdminMessagingPage'))}
                                />
                                <Route
                                    path={`${match.url}/report/:id/:parameter?/:parameterId?`}
                                    component={asyncComponent(() => import('./routes/ReportPage'))}
                                />
                                <Route path={`${match.url}/report-table`} component={asyncComponent(() => import('./routes/ReportTablePage'))} />
                                <Route path={`${match.url}/report-archive`} component={asyncComponent(() => import('./routes/ReportArchivePage'))} />
                                <Route path={`${match.url}/report-map`} component={asyncComponent(() => import('./routes/ReportMapPage'))} />
                                <Route path={`${match.url}/user-settings`} component={asyncComponent(() => import('./routes/UserSettingsPage'))} />
                                <Route path={`${match.url}/group-settings`} component={asyncComponent(() => import('./routes/GroupSettingsPage'))} />
                                <Route
                                    path={`${match.url}/administration-settings`}
                                    component={asyncComponent(() => import('./routes/AdministrationSettingsPage'))}
                                />
                                <Route
                                    path={`${match.url}/user/:id/:edit?/:tab?`}
                                    component={asyncComponent(() => import('./routes/UserProfilePage'))}
                                />
                                <Route
                                    path={`${match.url}/group/:id/:edit?/:tab?`}
                                    component={asyncComponent(() => import('./routes/GroupProfilePage'))}
                                />
                                <Route
                                    path={`${match.url}/citizen/:id/:edit?/:tab?`}
                                    component={asyncComponent(() => import('./routes/CitizenProfilePage'))}
                                />
                                <Route
                                    path={`${match.url}/organisation/:id/:edit?/:tab?`}
                                    component={asyncComponent(() => import('./routes/OrganisationProfilePage'))}
                                />
                                <Route path={`${match.url}/search`} component={asyncComponent(() => import('./routes/GeneralSearchPage'))} />
                                <Route path={`${match.url}/faq`} component={asyncComponent(() => import('./routes/FAQPage'))} />
                                <Route
                                    path={`${match.url}/admin-responsibilities`}
                                    component={asyncComponent(() => import('./routes/AdminResponsibilitiesPage'))}
                                />
                                <Route
                                    path={`${match.url}/admin-system-roles-settings/:roleId?`}
                                    component={asyncComponent(() => import('./routes/AdminSystemRolesSettingsPage'))}
                                />
                                <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./routes/DashboardPage'))} />
                                <Route path={`${match.url}/analysis`} component={asyncComponent(() => import('./routes/AnalysisPage'))} />
                                <Route path={`${match.url}/issue-table`} component={asyncComponent(() => import('./routes/IssueTablePage'))} />
                                <Route path={`${match.url}/issue-archive`} component={asyncComponent(() => import('./routes/IssueArchivePage'))} />
                                <Route path={`${match.url}/issue-analysis`} component={asyncComponent(() => import('./routes/IssueAnalysisPage'))} />
                                <Route
                                    path={`${match.url}/issue/:id/:parameter?/:parameterId?`}
                                    component={asyncComponent(() => import('./routes/IssuePage'))}
                                />
                                <Route component={asyncComponent(() => import('components/Error404'))} />
                            </Switch>
                        </div>
                        <Footer />
                    </main>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, profile, intro, accountSettings }) => {
    const { drawerType, navigationStyle, horizontalNavPosition } = settings;
    const { passwordExpired } = profile.myUserProfile;
    const { showTour, tourPage } = intro;
    return {
        drawerType,
        navigationStyle,
        horizontalNavPosition,
        passwordExpired,
        showTour,
        tourPage,
        organisationId: accountSettings.organisationStructure.organisationId
    };
};
export default withRouter(
    connect(
        mapStateToProps,
        { resetIntroTour }
    )(App)
);



// WEBPACK FOOTER //
// ./app/index.js